import React, { useEffect, useState, useRef } from "react";
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
// reactstrap components
import {
    Button,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
    Container,
    Row,
    Col,
} from "reactstrap";
import { handleResponse, authHeader } from '_helpers';


//function Visit() {
const SI = (props) => {
    const DocDT = (props.match.params.DocDT !== undefined) ? props.match.params.DocDT : null;
    const [renderItem, setRenderItem] = useState([]);


    useEffect(() => {

        fetch('/api/v1/softconimg/' + DocDT, {
            method: 'GET',
            headers: authHeader()
        })
            .then(handleResponse)
            //.then(response => response.json())
            .then(
                (result) => {
                    setRenderItem(result.data)
                },
                (error) => {
                    alert('not found')
                    setRenderItem([])
                }
        );


        document.body.classList.add("profile-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("profile-page");
            document.body.classList.remove("sidebar-collapse");
        };
    },[]);


    //const currentUser = authenticationService.currentUserValue;
    //if (!currentUser) {
    //    return <Redirect to={{ pathname: '/login', /*state: { from: props.location }*/ }} />
    //}
    const content = renderItem.map((post, index) =>
        <Row key={index} style={{ fontSize: '1em', padding: '10px 10px', borderBottom: '1px solid #dddddd' }}>
            <Col>
                {post.Code}
            </Col>
            <Col>
                {post.Name}
            </Col>
            <Col>
                {post.FileName}
            </Col>
            <Col>
                <img src={post.Thumbnail} />
            </Col>

        </Row>
    );

    return (
        <>
            <div className="wrapper">
                <div className="section" style={{ padding: 0 }}>
                    <Container>
                        {content}
                    </Container>
                </div>
            </div>
        </>
    );
}

export default SI;
